import { getActiveWorkspaceId } from '@/lib/api/workspace-context'

export interface WorkspaceContainerRef {
  id?: string | null
  ownerId?: string | null
}

interface ConversationRouteOptions {
  view?: 'chat' | 'workspace'
  moduleId?: string | null
  search?: string
}

function normalizeSearch(search?: string): string {
  if (!search) return ''
  return search.startsWith('?') ? search : `?${search}`
}

export function resolveWorkspaceId(container?: WorkspaceContainerRef | null): string {
  const direct = container?.id ?? container?.ownerId
  if (direct) return direct

  return getActiveWorkspaceId()
}

export function buildConversationPath(
  workspaceId: string,
  conversationId: string,
  options: ConversationRouteOptions = {},
): string {
  const base = `/w/${encodeURIComponent(workspaceId)}/c/${encodeURIComponent(conversationId)}`
  const search = normalizeSearch(options.search)

  if (options.moduleId) {
    return `${base}/mod/${encodeURIComponent(options.moduleId)}${search}`
  }

  if (options.view === 'chat') {
    return `${base}/chat${search}`
  }

  return `${base}${search}`
}
